import "./index.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

const style = document.createElement('style');
style.textContent = '* { margin: 0; padding: 0; box-sizing: border-box; } body { background: #080c14; }';
document.head.appendChild(style);
